'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp; /**
                                   * Created by lyj on 2016/10/22.
                                   */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRating = require('react-rating');

var _reactRating2 = _interopRequireDefault(_reactRating);

var _GoeasyInputField = require('../GoeasyInputField/GoeasyInputField');

var _GoeasyInputField2 = _interopRequireDefault(_GoeasyInputField);

var _reduxForm = require('redux-form');

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrderEvaluateComponent = (_dec = (0, _reduxForm.reduxForm)({
  form: 'orderEvaluateForm',
  fields: ['serviceEvaluateData', 'productEvaluateData']
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(OrderEvaluateComponent, _Component);

  function OrderEvaluateComponent() {
    (0, _classCallCheck3.default)(this, OrderEvaluateComponent);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(OrderEvaluateComponent).call(this));
  }
  // const styles = require('./OrderEvaluate.scss');


  (0, _createClass3.default)(OrderEvaluateComponent, [{
    key: 'onEvaluteChange',
    value: function onEvaluteChange(rate, type) {
      // console.log(rate);
      var serviceEvaluateData = this.props.fields.serviceEvaluateData;

      var serviceData = serviceEvaluateData.value || serviceEvaluateData.initialValue;
      var newServiceData = serviceData.map(function (item) {
        var newItem = (0, _extends3.default)({}, item);
        if (newItem.serviceTypeText === type) {
          newItem.serviceStar = rate;
        }
        // console.log(newItem);
        return newItem;
      });
      // console.log(newServiceData);
      serviceEvaluateData.onChange(newServiceData);
    }
  }, {
    key: 'onProductEvaluteChange',
    value: function onProductEvaluteChange(rate, id) {
      // console.log(rate);
      var productEvaluateData = this.props.fields.productEvaluateData;

      var productData = productEvaluateData.value || productEvaluateData.initialValue;
      var newProductData = productData.map(function (item) {
        var newItem = (0, _extends3.default)({}, item);
        if (newItem.productId === id) {
          newItem.star = rate;
        }
        return newItem;
      });
      productEvaluateData.onChange(newProductData);
    }
  }, {
    key: 'evaluateInit',
    value: function evaluateInit(value, id) {
      var productEvaluateData = this.props.fields.productEvaluateData;

      var productData = productEvaluateData.value || productEvaluateData.initialValue;
      var newProductData = productData.map(function (item) {
        var newItem = (0, _extends3.default)({}, item);
        if (newItem.productId === id) {
          newItem.evaluate = value;
        }
        return newItem;
      });
      productEvaluateData.onChange(newProductData);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props;
      var _props$fields = _props.fields;
      var serviceEvaluateData = _props$fields.serviceEvaluateData;
      var productEvaluateData = _props$fields.productEvaluateData;
      var orderEvaluate = _props.orderEvaluate;
      var
      // orderServiceEvaluate,
      // orderProductEvaluate,
      handleSubmit = _props.handleSubmit;

      var styles = require('./OrderEvaluateComponent.scss');
      var isEvaluated = false;
      if (orderEvaluate instanceof Array && orderEvaluate.length > 0 && orderEvaluate[0].isEvaluated === '1') {
        isEvaluated = true;
      }
      // isEvaluated = false;
      // console.log(serviceEvaluateData);
      // console.log('serviceEvaluateData');
      // console.log(JSON.stringify(serviceEvaluateData.initialValue));
      // console.log(JSON.stringify(serviceEvaluateData.value));
      var serviceData = serviceEvaluateData.value || serviceEvaluateData.initialValue;
      // console.log(JSON.stringify(serviceData));
      var serviceEvaluateDiv = _react2.default.createElement('div', null);
      if (serviceData instanceof Array && serviceData.length > 0) {
        serviceEvaluateDiv = _react2.default.createElement(
          'ul',
          { className: styles.serviceEvaluate },
          serviceData.map(function (serviceInfo, index) {
            var starNumber = parseInt(serviceInfo.serviceStar, 10);
            if (isNaN(starNumber)) {
              starNumber = 0;
            }
            return _react2.default.createElement(
              'li',
              { key: index + 'serviceEvaluate' },
              _react2.default.createElement(
                'div',
                { className: styles.serviceTip },
                serviceInfo.serviceTypeText
              ),
              _react2.default.createElement(_reactRating2.default, { initialRate: starNumber,
                readonly: isEvaluated,
                empty: 'fa fa-star-o fa-2x grey mr7',
                full: 'fa fa-star fa-2x red mr7',
                onChange: function onChange(rate) {
                  return _this2.onEvaluteChange(rate, serviceInfo.serviceTypeText);
                } })
            );
          })
        );
      }
      // console.log('productEvaluateData');
      // console.log(JSON.stringify(productEvaluateData.initialValue));
      // console.log(JSON.stringify(productEvaluateData.value));
      var productData = productEvaluateData.value || productEvaluateData.initialValue;
      // console.log(JSON.stringify(productData));
      var productsEvaluateDiv = _react2.default.createElement('div', null);
      if (productData instanceof Array && productData.length > 0) {
        productsEvaluateDiv = productData.map(function (productInfo, index) {
          // console.log(productInfo.evaluate);
          var evaluateText = _react2.default.createElement(_GoeasyInputField2.default, { goeasyStyle: { width: 580, float: 'left', marginTop: 0 },
            afterInit: _this2.evaluateInit.bind(_this2),
            inputType: 'textarea',
            inputStyle: { float: 'left', width: 580 },
            inputPlaceholder: productInfo.evaluate,
            orderEvaluate: 'orderEvaluate',
            productId: productInfo.productId
          });
          if (isEvaluated) {
            evaluateText = _react2.default.createElement(_GoeasyInputField2.default, { goeasyStyle: { width: 580, float: 'left', marginTop: 0 },
              afterInit: function afterInit(value) {
                return _this2.evaluateInit(value, productInfo.id);
              },
              inputType: 'textarea',
              disabled: isEvaluated,
              inputStyle: { float: 'left', width: 580 },
              inputPlaceholder: '',
              value: productInfo.evaluate });
          }
          var starNumber = parseInt(productInfo.star, 10);
          if (isNaN(starNumber)) {
            starNumber = 0;
          }
          return _react2.default.createElement(
            'div',
            { className: styles.productEvaluate, key: index + 'orderEvaluate' },
            _react2.default.createElement(
              'div',
              { className: styles.left },
              _react2.default.createElement('img', { src: productInfo.img }),
              _react2.default.createElement(
                'span',
                null,
                productInfo.name
              )
            ),
            _react2.default.createElement(
              'ul',
              { className: styles.right },
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'div',
                  { className: styles.serviceTip },
                  '商品满意度'
                ),
                _react2.default.createElement(_reactRating2.default, {
                  initialRate: starNumber,
                  readonly: isEvaluated,
                  empty: 'fa fa-star-o fa-2x grey mr7',
                  full: 'fa fa-star fa-2x red mr7',
                  onChange: function onChange(rate) {
                    return _this2.onProductEvaluteChange(rate, productInfo.productId);
                  } })
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'div',
                  { className: styles.serviceTip },
                  '评价晒单'
                ),
                evaluateText
              )
            ),
            _react2.default.createElement('div', { className: 'clear' }),
            _react2.default.createElement('div', { style: { width: '100%', height: 20, borderBottom: '1px solid #ececec' } })
          );
        });
      }
      return _react2.default.createElement(
        'div',
        { className: styles.component },
        _react2.default.createElement(
          'div',
          { className: styles.topTitle },
          '订单编号：',
          orderEvaluate && orderEvaluate.length > 0 ? orderEvaluate[0].orderId : '',
          _react2.default.createElement(
            'div',
            { className: styles.orderStatus },
            '状态：',
            orderEvaluate && orderEvaluate.length > 0 ? orderEvaluate[0].status : ''
          )
        ),
        _react2.default.createElement('div', { className: styles.xiola }),
        _react2.default.createElement('div', { className: styles.xiolb }),
        _react2.default.createElement('div', { className: styles.xiolc }),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(
          'div',
          { className: styles.topTitle,
            style: { paddingTop: '8px', float: 'right' } },
          orderEvaluate && orderEvaluate.length > 0 ? orderEvaluate[0].time : ''
        ),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(
          'div',
          { className: styles.newPage },
          _react2.default.createElement(
            'div',
            { className: styles.pageTopTitle },
            '服务评价'
          ),
          _react2.default.createElement('div', { className: styles.linka }),
          _react2.default.createElement('div', { className: 'clear' }),
          serviceEvaluateDiv,
          _react2.default.createElement('div', { className: 'clear' }),
          _react2.default.createElement(
            'div',
            { className: styles.pageTopTitle },
            '艺品评价'
          ),
          _react2.default.createElement('div', { className: styles.linka }),
          _react2.default.createElement('div', { className: 'clear' }),
          productsEvaluateDiv
        ),
        _react2.default.createElement(
          'div',
          { className: styles.linkBtn, style: { width: isEvaluated ? 120 : 305 } },

          // isEvaluated ? <Link className={styles.btn} to={'/orderlist'}>返回</Link> : <div className={styles.btn} onClick={handleSubmit}>评价提交</div>
          isEvaluated ? '' : _react2.default.createElement(
            'div',
            { className: styles.btn, onClick: handleSubmit, style: { marginRight: 60 } },
            '评价提交'
          ),
          _react2.default.createElement(
            _reactRouter.Link,
            { className: styles.btn, to: '/orderlist' },
            '返回'
          )
        ),
        _react2.default.createElement('div', { className: 'clear' })
      );
    }
  }]);
  return OrderEvaluateComponent;
}(_react.Component), _class2.propTypes = {
  active: _react.PropTypes.string,
  asyncValidating: _react.PropTypes.bool.isRequired,
  fields: _react.PropTypes.object.isRequired,
  dirty: _react.PropTypes.bool.isRequired,
  resetForm: _react.PropTypes.func.isRequired,
  invalid: _react.PropTypes.bool.isRequired,
  pristine: _react.PropTypes.bool.isRequired,
  valid: _react.PropTypes.bool.isRequired,
  handleSubmit: _react.PropTypes.func,

  // data: PropTypes.object
  orderEvaluate: _react.PropTypes.array,
  orderServiceEvaluate: _react.PropTypes.array,
  orderProductEvaluate: _react.PropTypes.array
}, _temp)) || _class);
exports.default = OrderEvaluateComponent;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/OrderEvaluateComponent/OrderEvaluateComponent.js
 ** module id = 1383
 ** module chunks = 0
 **/